import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface ProjectStorySetupStepProps {
  projectData: {
    name: string;
    description: string;
    genre: string;
  };
  setProjectData: (data: any) => void;
  storyData: {
    name: string;
    plotline: string;
    genre: string;
  };
  setStoryData: (data: any) => void;
}

export function ProjectStorySetupStep({
  projectData,
  setProjectData,
  storyData,
  setStoryData
}: ProjectStorySetupStepProps) {

  const handleNameChange = (val: string) => {
    setProjectData({ ...projectData, name: val });
    setStoryData({ ...storyData, name: val });
  };

  const handleGenreChange = (val: string) => {
    setProjectData({ ...projectData, genre: val });
    setStoryData({ ...storyData, genre: val });
  };

  const handleDescriptionChange = (val: string) => {
    setProjectData({ ...projectData, description: val });
    setStoryData({ ...storyData, plotline: val });
  };

  const inputClasses = "h-12 rounded-xl bg-muted/5 border-border/50 focus:border-primary/30 focus:ring-0 transition-all font-medium text-foreground placeholder:text-muted-foreground/30 shadow-none";
  const textareaClasses = "min-h-[160px] rounded-xl bg-muted/5 border-border/50 focus:border-primary/30 focus:ring-0 transition-all text-foreground placeholder:text-muted-foreground/30 shadow-none resize-none p-5 text-base leading-relaxed";
  const labelClasses = "text-[10px] font-bold uppercase tracking-wider text-muted-foreground/60 mb-2 block ml-1";

  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-2 duration-700">
      {/* Step Header */}
      <div className="space-y-3">
        <h1 className="text-3xl font-bold tracking-tight text-foreground font-lora">
          Tell me about your story
        </h1>
        <p className="text-muted-foreground text-sm leading-relaxed max-w-md">
          A braindump, a one-liner, or just a vibe. The more you give, the better the AI writes from day one.
        </p>
      </div>

      <div className="space-y-6">
        {/* Description Field (Now First) */}
        <div className="space-y-2">
          <Textarea
            id="description"
            placeholder="Throw in characters, world, references, things you definitely don't want..."
            value={storyData.plotline}
            onChange={(e) => handleDescriptionChange(e.target.value)}
            className={textareaClasses}
            autoFocus
          />
        </div>

        {/* Title and Genre Side-by-Side */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="space-y-1">
            <Label htmlFor="title" className={labelClasses}>
              Title (optional)
            </Label>
            <Input
              id="title"
              placeholder="e.g. The Cartographer's Curse"
              value={projectData.name}
              onChange={(e) => handleNameChange(e.target.value)}
              className={inputClasses}
            />
          </div>

          <div className="space-y-1">
            <Label htmlFor="genre" className={labelClasses}>
              Genre
            </Label>
            <Input
              id="genre"
              placeholder="Fantasy, Mystery..."
              value={projectData.genre}
              onChange={(e) => handleGenreChange(e.target.value)}
              className={inputClasses}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
